import { Mutations } from "vuex-smart-module";
import UsersState from "@/store/modules/users/usersState";
import UserModel from "@/models/UserModel";

export default class UsersMutations extends Mutations<UsersState> {
  setUsers(payload: UserModel[]): void {
    this.state.users = payload;
  }
}
